import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import useUniqueId from "../../Hooks/useUniqueId";
import A11yHelpers from "../../../../util/A11yHelpers";
const Leaf = ({ leaf, onClick, }) => (_jsx("li", Object.assign({ className: "dropdown-item clickable", 
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    role: "button", tabIndex: 0 }, A11yHelpers.onClickOrEnterOrSpace(() => onClick()), { children: leaf.text })));
const Parent = ({ menu, onClick, }) => (_jsxs("li", { className: "dropdown-submenu", children: [_jsx("a", { "data-toggle": "dropdown", className: "dropdown-item dropdown-toggle", children: menu.text }), _jsx("ul", { className: "dropdown-menu", children: menu.menus.map((item, itemIndex) => "menus" in item ? (_jsx(Parent, { menu: item, onClick: onClick }, itemIndex)) : (_jsx(Leaf, { leaf: item, onClick: () => onClick(item.value) }, itemIndex))) })] }));
// TODO this doesn't work with menus that are children of menus.
const MenuInput = (props) => {
    const [uniqueId] = useUniqueId();
    const inputGroup = React.useRef(null);
    const input = React.useRef(null);
    React.useLayoutEffect(() => {
        if (!inputGroup.current) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return () => { };
        }
        const inputGroupJquery = $(inputGroup.current);
        const dropdowns = inputGroupJquery.find(".dropdown-menu a.dropdown-toggle");
        dropdowns.on("click", function handleClick() {
            // Hide all dropdowns
            inputGroupJquery.find(".dropdown-submenu .show").removeClass("show");
            inputGroupJquery.find(".dropdown-submenu .open").removeClass("open");
            // Show this dropdown
            const subMenu = $(this).next(".dropdown-menu");
            subMenu.toggleClass("show");
            // Add open class to button
            subMenu.siblings(".dropdown-toggle").addClass("open");
            const parents = $(this).parents(".dropdown.show");
            parents.off("hidden.bs.dropdown");
            parents.on("hidden.bs.dropdown", function handleHide() {
                inputGroupJquery.find(".dropdown-submenu .show").removeClass("show");
                inputGroupJquery.find(".dropdown-submenu .open").removeClass("open");
            });
            return false;
        });
        return () => {
            dropdowns.off("click");
        };
    }, [props.menus]);
    const getCaretPosition = () => input.current && $(input.current).prop("selectionStart");
    const focusOnInput = (caretPos = 0) => {
        const elm = input.current;
        if (!elm) {
            return;
        }
        if ("createTextRange" in elm) {
            // @ts-expect-error I can't find any documentation on this, but it works... leaving for now
            const range = elm.createTextRange();
            range.move("character", caretPos);
            range.select();
        }
        else if (elm.setSelectionRange) {
            elm.focus();
            elm.setSelectionRange(caretPos, caretPos);
        }
        else {
            elm.focus();
        }
    };
    const setVariable = (variable) => {
        const caretPosition = getCaretPosition() || 0;
        let newValue;
        if (props.value) {
            const oldValue = props.value;
            newValue =
                oldValue.substring(0, caretPosition) +
                    (props.prefixWithDollarSign ? "$" : "") +
                    "{" +
                    variable +
                    "}" +
                    oldValue.substring(caretPosition);
        }
        else {
            newValue = (props.prefixWithDollarSign ? "$" : "") + "{" + variable + "}";
        }
        if (props.onChange) {
            props.onChange(newValue);
        }
        // Give the component some time to render.  I know this is kinda hack-y to do with a set timeout, but I couldn't
        // find a way to make this work with effects or layout effects.
        setTimeout(() => focusOnInput(caretPosition +
            variable.length +
            "{}".length +
            (props.prefixWithDollarSign ? 1 : 0)), 100);
    };
    const hasSubmenus = props.menus.some((m) => "menus" in m);
    return (_jsxs("div", { className: "input-group", ref: inputGroup, children: [_jsxs("div", { className: "input-group-prepend", children: [_jsx("button", { className: classNames("btn btn-primary dropdown-toggle", {
                            "btn-danger": props.isInvalid,
                        }), type: "button", id: uniqueId + "-menuInputButton", style: { zIndex: 0 }, "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false", children: "Insert" }), _jsx("ul", { className: "dropdown-menu shadow custom-scrollbar", 
                        /* We add a maxHeight because long dropdowns can go off the screen, making their
                         * lower items inaccessible.  However, if the menu has submenus, adding the
                         * overflowY scroll totally breaks them.  So, we're just hoping that we
                         * don't have any tall menus with submenus.
                         */
                        style: hasSubmenus ? {} : { maxHeight: 190, overflowY: "scroll" }, "aria-labelledby": uniqueId + "-menuInputButton", children: props.menus
                            // Don't show menu items that are links.  We can't show links in plain text.
                            .filter((menu) => !("link" in menu && menu.link != null))
                            .map((menu, menuIndex) => "menus" in menu ? (_jsx(Parent, { menu: menu, onClick: (text) => setVariable(text) }, menuIndex)) : (_jsx(Leaf, { leaf: menu, onClick: () => setVariable(menu.value) }, menuIndex))) })] }), _jsx("input", { type: "text", className: classNames("form-control", {
                    "is-invalid": props.isInvalid,
                }), id: props.id || uniqueId + "-menuInputInput", autoComplete: "off", name: props.name, value: props.value, "aria-labelledby": props["aria-labelledby"], onChange: (e) => props.onChange && props.onChange(e.target.value), ref: input }), props.invalidMessage && (_jsx("div", { className: "invalid-feedback", children: props.invalidMessage }))] }));
};
export default MenuInput;
